module.exports = __webpack_public_path__ + "static/media/poikiliamd_thumb2.e4f1eb05.jpg";